import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ProtectedLayout = ({ children }) => {
  const navigate = useNavigate();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem('user');
    const password = localStorage.getItem('pass');

    if (!username || !password) {
      navigate('/Login');
      return;
    }

    fetch('https://promo.myservicecircle.app/webservice/loginCheck.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success === 1) setAuthChecked(true);
        else navigate('/Login');
      })
      .catch(() => navigate('/Login'));
  }, [navigate]);

  return authChecked ? <>{children}</> : null;
};

export default ProtectedLayout;
